import React from 'react';
import classNames from 'classnames/bind';
import Title from "../../../../../Title";
import { Markup } from "../../../../../internal/Markup";
import { TextBase } from "../../../../../internal/TextBase";
import { MobileAccordionItem } from '../../MobileAccordionItem';
import { SearchLink } from '../../SearchLink';
import styles from '../MobileMenuCanary.css';
var cx = classNames.bind(styles);
export var B2BMenu = function B2BMenu(_ref) {
  var navigation = _ref.navigation,
      onClose = _ref.onClose,
      theme = _ref.theme,
      toggleAccordionItem = _ref.toggleAccordionItem,
      accordionExpandedItems = _ref.accordionExpandedItems,
      setSubmenu = _ref.setSubmenu;

  var getAccordionChild = function getAccordionChild(_ref2) {
    var item = _ref2.item,
        parentIndex = _ref2.parentIndex,
        index = _ref2.index;

    if (item.href) {
      return /*#__PURE__*/React.createElement(SearchLink, {
        href: item.href,
        title: item.title,
        onClick: onClose,
        theme: theme
      });
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      key: item.title,
      className: cx('item'),
      onClick: function onClick() {
        return setSubmenu === null || setSubmenu === void 0 ? void 0 : setSubmenu([parentIndex, index]);
      },
      type: "button"
    }, /*#__PURE__*/React.createElement(TextBase, {
      size: "l",
      as: "span",
      color: "N100"
    }, /*#__PURE__*/React.createElement(Markup, {
      text: item.title
    }))), item.points && /*#__PURE__*/React.createElement("span", {
      className: cx('nested-points-count')
    }, /*#__PURE__*/React.createElement(TextBase, {
      size: "s",
      color: "N300"
    }, item.points.length)));
  };

  return /*#__PURE__*/React.createElement("ul", {
    className: cx('items')
  }, navigation.map(function (navigationItem, parentIndex) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, navigationItem.items && navigationItem.items.length > 0 ? /*#__PURE__*/React.createElement(MobileAccordionItem, {
      key: navigationItem.title,
      onOpenChange: function onOpenChange() {
        return toggleAccordionItem(parentIndex);
      },
      open: accordionExpandedItems.includes(parentIndex),
      title: navigationItem.title,
      subtitle: navigationItem.subtitle,
      classes: {
        root: cx({
          'active-item': navigationItem.active
        })
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('accordion-children')
    }, navigationItem.items.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: cx('accordion-child')
      }, getAccordionChild({
        item: item,
        parentIndex: parentIndex,
        index: index
      }));
    }))) : /*#__PURE__*/React.createElement("li", {
      key: navigationItem.title,
      className: cx('item', "item-".concat(theme), {
        'active-item': navigationItem.active
      })
    }, /*#__PURE__*/React.createElement("a", {
      onClick: onClose,
      href: navigationItem.href,
      className: cx('b2b-link')
    }, /*#__PURE__*/React.createElement(Title, {
      level: 3
    }, /*#__PURE__*/React.createElement(Markup, {
      text: navigationItem.title
    })))));
  }));
};